export default function HeroSection() {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[580px] md:min-h-[650px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20dark%20atmosphere%20with%20warm%20golden%20and%20deep%20crimson%20accents%2C%20abstract%20film%20reel%20textures%20blending%20into%20a%20theater%20curtain%20backdrop%2C%20soft%20spotlight%20glow%20from%20upper%20left%2C%20rich%20velvet%20red%20undertones%20with%20deep%20charcoal%20shadows%2C%20elegant%20cinematic%20composition%20with%20bokeh%20effect%2C%20no%20text%20no%20people%2C%20high%20contrast%20dramatic%20lighting%20suitable%20for%20movie%20streaming%20website%20hero%20background&width=1800&height=900&seq=hero-bg-aidou-01&orientation=landscape"
          alt="爱豆影视 - 沉浸式观影体验"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20 max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">

          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/20 text-primary-300 text-xs md:text-sm font-medium mb-5 border border-primary-500/30">
              每日更新 · 片源充足
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-background-50 leading-tight mb-4">
              爱豆影视 · 高清流畅免费在线观看
            </h1>

            <p className="text-lg md:text-xl text-background-50/80 font-light mb-3">
              不缓冲 · 不卡顿 · 随时随地畅享精彩
            </p>

            <p className="text-sm md:text-base text-background-50/60 leading-relaxed mb-7 max-w-xl lg:max-w-none">
              爱豆影视汇聚海量电视剧、电影、综艺资源，每日同步更新最新热播高分全集。采用先进播放技术，确保高清画质下流畅不缓冲，让每一次观影都成为享受。无论热门大剧、经典老片还是小众佳作，这里都能轻松找到。无需注册，打开即看，真正实现自由观影。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">20000+</div>
                <div className="text-xs text-background-50/50 mt-1">影视资源</div>
              </div>
              <div className="w-px h-10 bg-background-50/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">每日更新</div>
                <div className="text-xs text-background-50/50 mt-1">同步热播</div>
              </div>
              <div className="w-px h-10 bg-background-50/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-400">高清流畅</div>
                <div className="text-xs text-background-50/50 mt-1">不缓冲不卡顿</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => handleScroll(e, '#media')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观影
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScroll(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 border border-background-50/20 font-medium rounded-full text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                热播榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-[500px]">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-black/40">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20collage%20composition%20with%20warm%20golden%20and%20deep%20red%20tones%2C%20abstract%20film%20scenes%20blending%20together%2C%20dramatic%20lighting%20with%20lens%20flare%20from%20upper%20right%2C%20movie%20clapperboard%20and%20film%20strip%20elements%20subtly%20integrated%2C%20rich%20textured%20background%20with%20velvet%20curtain%20feel%2C%20entertainment%20and%20streaming%20vibe%2C%20no%20text%20no%20recognizable%20people%2C%20artistic%20cinematic%20poster%20style%2C%20warm%20atmospheric%20lighting&width=1000&height=700&seq=hero-visual-aidou-01&orientation=landscape"
                alt="爱豆影视主视觉 - 热门影视精选合集"
                className="w-full h-auto object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 md:p-5">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-primary-500 flex items-center justify-center">
                    <i className="ri-play-fill text-background-50 text-xl"></i>
                  </div>
                  <div>
                    <div className="text-background-50 text-sm md:text-base font-semibold">今日热播精选</div>
                    <div className="text-background-50/60 text-xs">海量高分影视一网打尽</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}